module.exports = __webpack_public_path__ + "static/media/404.267b91af.png";